import { render, staticRenderFns } from "./VehicleComponentGroup.vue?vue&type=template&id=22aeab7b&scoped=true"
import script from "./VehicleComponentGroup.vue?vue&type=script&lang=js"
export * from "./VehicleComponentGroup.vue?vue&type=script&lang=js"
import style0 from "./VehicleComponentGroup.vue?vue&type=style&index=0&id=22aeab7b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aeab7b",
  null
  
)

export default component.exports